const {
  keysSortedByValueAscending
} = require('@truqc/content-path');

// const moment = require('moment-timezone');
const momentTimezone = require('moment-timezone');
const momentStandard = require('moment');
const moment = {
  utc: momentTimezone.utc || momentStandard.utc
};
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate titleComponentsBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const components = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  const evaluatedTimeZone = await evaluateSource(source.timeZone, content, parentContentPath, transientContext, nativeFunctions);
  const titles = [];
  keysSortedByValueAscending(components).forEach(key => {
    const {
      text,
      date
    } = components[key];
    if (text !== undefined) {
      titles.push(text);
    } else if (date !== undefined) {
      try {
        const dateTime = moment.utc(new Date(date));
        const zonedDateTime = evaluatedTimeZone === undefined ? dateTime.local() : dateTime.tz(evaluatedTimeZone);
        titles.push(zonedDateTime.format('MM/DD/YYYY, h:mm A'));
      } catch (_unused) {
        titles.push('undefined');
      }
    }
  });
  return titles.join(', ');
};
module.exports = {
  evaluate
};